module.exports = __webpack_public_path__ + "assets/497398908a2e75d1c532b37757762c53.mp3";